import Home from '@/views/Login.vue'
import Registrarse from '@/views/Registrarse.vue'
import Recuperar from '@/views/Recuperar.vue'
import OpcionesRegistro from '@/views/OpcionesRegistro.vue'
import Verificar from '@/views/VerificarCodigo.vue'
import Cambio from '@/views/CambioContrasena.vue'
import ConfirmarUbicacion from '@/views/ConfirmarUbicacion.vue'
import ConfirmarTelefono from '@/views/ConfirmarTelefono.vue'
import SeleccionDistribuidor from '@/views/SeleccionDistribuidor.vue'
import NuevaContrasena from '@/components/NuevaContrasena/NuevaContrasena.vue'
import LoginGeneral  from '@/components/LoginGeneral/LoginGeneral.vue'
import NotFound from '@/views/NotFound.vue'
import ReenviarCodigo from '@/views/ReenviarCodigo.vue'
import ModificarDatos from '@/views/ModificarDatos.vue'

export default [{
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/registrarse',
    name: 'Alta de cuenta',
    component: Registrarse
  },
  {
    path: '/recuperar',
    name: 'Recuperar contraseña',
    component: Recuperar
  },
  {
    path: '/verificar',
    name: 'Verificar código',
    component: Verificar
  },
  {
    path: '/cambio',
    name: 'Cambiar contraseña',
    component: Cambio
  },
  {
    path: '/confirmar_ubiacion',
    name: 'Confirmar Ubicación',
    component: ConfirmarUbicacion
  },
  {
    path: '/confirmar_telefono',
    name: 'Confirmar Teléfono',
    component: ConfirmarTelefono
  },
  {
    path: '/distribuidor',
    name: 'Distribuidor',
    component: SeleccionDistribuidor
  },
  {
    path: '/nueva_contrasena',
    name: 'NuevaContrasena',
    component: NuevaContrasena
  },
  {
    path: '/login_general',
    name: 'LoginGeneral',
    component: LoginGeneral    
  },
  {
    path: '/404',
    name: '404',
    component: NotFound    
  },{
    path: '/opciones_registro',
    name: 'Opciones registro',
    component: OpcionesRegistro
  },{
    path: '/reenviar_codigo',
    name: 'Reenviar código',
    component: ReenviarCodigo
  },{
    path: '/modificar_datos',
    name: 'Modificar Datos',
    component: ModificarDatos
  },
]